module.exports = __webpack_public_path__ + "static/media/sign-out.9c8e1262.svg";